// extracted by mini-css-extract-plugin
export default {"mainWrapper":"NetworkStatus_mainWrapper__lC1Yj","mainContainer":"NetworkStatus_mainContainer__2+8eT","backgroundImage":"NetworkStatus_backgroundImage__FT6Vo"};